<template>

  <div>

    <h3>Site Tenancy</h3>
    <div v-if="tenancyData" v-for="(tenancy, index) in tenancyData">
      <table class="el-table">
        <thead>
          <th>Land Type</th>
          <th>Landlord</th>
          <th>Deposit</th>
          <th>Deposit (m.)</th>
          <th>Amount</th>
          <th>Frequency</th>
          <th>Increment</th>
        </thead>
        <tbody>
        <tr>
          <td>{{tenancy.landType}}</td>
          <td>{{tenancy.owner.name}}</td>
          <td>{{formatNumber(tenancy.deposit)}}</td>
          <td>{{formatInteger(tenancy.depositMonths)}}</td>
          <td>{{formatNumber(tenancy.landValue)}}</td>
          <td>{{tenancy.frequency}}</td>
          <td>{{formatPercent(tenancy.increment)}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <hr />

  <site-finance-tenancy :row-data="rowData" />

  </div>


</template>



<script>

import SiteFinanceTenancy from '@/components/sites/finance/tenancy/SiteFinanceTenancy'

export default {
  components: {
    SiteFinanceTenancy
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },

    tenancyData: {
      type: Object,
      default: null
    },

    editMode: {
      type: Boolean,
      default: false
    }
  },


  data () {
    return {
      editing: this.editMode
    }
  }
}
</script>
